import { isTauri } from './tauri';

/**
 * Open a URL outside the app — in the user's real browser, or their mail client
 * for a `mailto:`.
 *
 * Why this exists rather than a bare `window.open`: inside the Tauri webview
 * there is no popup to open. `window.open` is not an error there, it is a
 * SILENT no-op — the button clicks, nothing happens, and nothing lands in the
 * console. That is exactly how the Settings → About resource rows shipped
 * broken while working perfectly in `npm start` (a normal browser, where
 * `window.open` does what it says).
 *
 * So: shell plugin on the desktop, `window.open` only on the web build. The
 * `catch` covers the case where the plugin import or the OS handoff fails —
 * on the desktop that fallback is itself a no-op, but it is strictly better
 * than an unhandled rejection.
 */
export async function openExternal(url) {
  if (!url) return;

  try {
    if (isTauri()) {
      const { open } = await import('@tauri-apps/plugin-shell');
      await open(url);
      return;
    }
  } catch {
    /* fall through to the web path */
  }

  window.open(url, '_blank', 'noopener,noreferrer');
}

export default openExternal;
